import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { InfoBox, InputGroup, fmtCur } from '../Common';

const FracTool = () => {
    const [cap, setCap] = useState(1000000);
    const [rp, setRp] = useState(0.5);
    const [sl, setSl] = useState(10);
    const [ls, setLs] = useState(65);

    const ramt = cap * (rp / 100);
    const lpl = sl * ls;
    const lots = lpl > 0 ? ramt / lpl : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Fixed Fractional Sizing</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital" value={cap} onChange={setCap} />
                <InputGroup label="Risk %" value={rp} onChange={setRp} />
                <InputGroup label="SL Pts" value={sl} onChange={setSl} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-blue">
                    <div className="tct-data-row"><span className="tct-label">Risk Amount</span><span className="tct-value">{fmtCur.format(ramt)}</span></div>
                    <div className="tct-data-row"><span className="tct-label">Lots Permitted</span><span className="tct-value big-value val-blue">≈ {Math.floor(lots)} lots</span></div>
                </div>
            </div>
            <InfoBox
                title="Fixed Fractional Position Sizing for Traders"
                meta="Understand how fixed fractional position sizing protects trading capital and controls risk"
                sections={[
                    { title: "Introduction", content: "Fixed fractional sizing means risking a constant percentage of capital per trade." },
                    { title: "Example", content: "Capital = ₹10L<br>Risk per trade = 0.5%<br><br>Allowed risk = ₹5000.<br><br>This ensures consistent risk management." }
                ]}
            />
        </div>
    );
};

export default FracTool;
